// Key rules of the user-preferences store (SPEC-0060/0061 integration contract §2), kept free of
// any runtime import so reducers and pure helpers can use them without loading the app's i18n.
export const PREFERENCE_SCHEMA_VERSION = 1;

export const USER_SCOPE = "user";
export const portfolioScope = (portfolioId) => `portfolio:${portfolioId}`;
export const projectScope = (projectId) => `project:${projectId}`;

export const PREF_KEY_PATTERN = /^[A-Za-z0-9_:-]{1,128}$/;
export const DASHBOARD_KEY_PATTERN = /^[a-z0-9-]{1,40}$/;
export const OFFOLIO_STANDARD_DASHBOARD_KEY = "offolio-standard";

export const DASHBOARD_TYPOLOGY = Object.freeze({
  RESOURCE_CAPACITY: "resource_capacity",
  ROADMAP: "roadmap",
  MONITORING: "monitoring",
});

export const dashboardPrefKey = (typology, dashboardKey) => `dashboard:${typology}:${dashboardKey}`;
export const dashboardPointerPrefKey = (typology) => `dashboard:${typology}:current`;
export const ganttViewPrefKey = (viewId) => `gantt_view:${viewId}`;
export const viewColumnsPrefKey = (viewId) => `view_columns:${String(viewId).replace(/\./g, "_")}`;
export const LOCAL_PREFS_IMPORT_FLAG_KEY = "migration:local-prefs-v1";
